import * as Types from '../../../../../api/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type StatusPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type StatusPageQuery = { __typename?: 'Query', Profile?: { __typename?: 'Profile', statusPage?: { __typename?: 'StatusPage', components: Array<{ __typename?: 'StatusPageComponent', _id: string, groupId?: string | null, displayMode: Types.StatusPageComponentDisplayMode, name: Array<{ __typename?: 'LocalizedString', language: string, value: string }>, description?: Array<{ __typename?: 'LocalizedString', language: string, value: string }> | null, eventsHistory: Array<{ __typename?: 'StatusPageComponentEventHistoryDate', date: string, events: Array<{ __typename?: 'StatusPageEvent', _id: string, ongoing: boolean, historyItems: Array<{ __typename?: 'StatusPageEventHistoryItem', _id: string, status: Types.StatusPageEventHistoryItemStatus, affectedComponents: Array<{ __typename?: 'StatusPageEventHistoryItemAffectedComponent', componentId: string, componentStatus: Types.StatusPageEventHistoryItemComponentStatus }> }> }> }> }> } | null } | null };


export const StatusPageDocument = gql`
    query StatusPage {
  Profile {
    statusPage {
      components {
        _id
        groupId
        displayMode
        name {
          language
          value
        }
        description {
          language
          value
        }
        eventsHistory(days: 1) {
          date
          events {
            _id
            ongoing
            historyItems {
              _id
              status
              affectedComponents {
                componentId
                componentStatus
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useStatusPageQuery__
 *
 * To run a query within a React component, call `useStatusPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatusPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatusPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StatusPageQuery, StatusPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StatusPageQuery, StatusPageQueryVariables>(StatusPageDocument, options);
      }
export function useStatusPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StatusPageQuery, StatusPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StatusPageQuery, StatusPageQueryVariables>(StatusPageDocument, options);
        }
export type StatusPageQueryHookResult = ReturnType<typeof useStatusPageQuery>;
export type StatusPageLazyQueryHookResult = ReturnType<typeof useStatusPageLazyQuery>;
export type StatusPageQueryResult = ApolloReactCommon.QueryResult<StatusPageQuery, StatusPageQueryVariables>;